"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSortablejs = _interopRequireDefault(require("react-sortablejs"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faGripLines = require("@fortawesome/pro-regular-svg-icons/faGripLines");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SortableRow = _styledComponents["default"].tr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: grab;\n\n    &:active {\n        cursor: grabbing;\n    }\n\n    &.sortable-chosen {\n        opacity: 0.7;\n    }\n\n    &.sortable-ghost {\n        background-color: ", ";\n        color: ", ";\n        .btn {\n            opacity: 0;\n        }\n    }\n\n    td {\n        vertical-align: middle;\n    }\n"])), function (props) {
  return props.theme.admin.colors.background;
}, function (props) {
  return props.theme.admin.colors.background;
});

var ContentProductRelationshipsList = function ContentProductRelationshipsList(props) {
  var settings = props.settings,
      setSettings = props.setSettings;
  var contentProductLinks = settings.contentProductLinks;
  return (contentProductLinks === null || contentProductLinks === void 0 ? void 0 : contentProductLinks.length) > 0 ? /*#__PURE__*/_react["default"].createElement("table", {
    className: "table table-sm mt-3",
    "data-testid": "related-products-list"
  }, /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
    width: "5%"
  }), /*#__PURE__*/_react["default"].createElement("col", {
    width: "60%"
  }), /*#__PURE__*/_react["default"].createElement("col", {
    width: "15%"
  })), /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null), /*#__PURE__*/_react["default"].createElement("th", null, "Name"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-right"
  }, "Remove"))), /*#__PURE__*/_react["default"].createElement(_reactSortablejs["default"], {
    tag: "tbody",
    onChange: function onChange(order, sortable, evt) {
      var values = _toConsumableArray(contentProductLinks);

      var movedItem = values[evt.oldIndex];
      var to = evt.newIndex;
      values.splice(evt.oldIndex, 1);
      values.splice(to, 0, movedItem);
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        contentProductLinks: values
      }));
    },
    options: {
      animation: 100
    }
  }, contentProductLinks.map(function (item, index) {
    var _item$product;

    return /*#__PURE__*/_react["default"].createElement(SortableRow, {
      key: item.id,
      "data-id": item.id
    }, /*#__PURE__*/_react["default"].createElement("td", {
      "data-testid": "product-".concat(index, "-slider")
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faGripLines.faGripLines
    })), /*#__PURE__*/_react["default"].createElement("td", {
      "data-testid": "product-".concat(index, "-name")
    }, (item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.name) || item.name || '-'), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-right"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-sm btn-danger",
      onClick: function onClick() {
        var values = _toConsumableArray(contentProductLinks);

        values.splice(index, 1);
        setSettings(_objectSpread(_objectSpread({}, settings), {}, {
          contentProductLinks: values
        }));
      },
      "data-testid": "product-".concat(index, "-remove"),
      style: {
        backgroundColor: '#dc3545'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTrash.faTrash
    }))));
  }))) : /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center my-3",
    "data-testid": "no-products"
  }, "No products assigned to this content");
};

var _default = ContentProductRelationshipsList;
exports["default"] = _default;